import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const oneTimePaymentPlansStyles = {
	creditsComp: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'start',
		gap: '32px',

		'& svg': { height: '24px', width: 'auto' },
	},
	getFreeCreditsButton: {
		padding: '10 16px',
		minWidth: '240px',
		borderRadius: '4px',
		border: `1px solid ${colorPalette.light5}`,

		textTransform: 'none',
	},
	coinSvgIcon: {
		display: 'flex',

		'& svg': {
			height: '16px',
			width: 'auto',
		},
	},
	addCreditsCard: {
		flexGrow: 1,
		padding: '12px 16px',
		borderRadius: '4px',

		backgroundColor: 'colors.dark4',

		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'start',
		gap: '12px',

		position: 'relative',
		cursor: 'pointer',
	},
	mostBoughtBadge: {
		position: 'absolute',
		top: '-1px',
		right: '-1px',

		padding: '2px 12px',
		borderRadius: '0 4px 0 4px',

		backgroundColor: 'colors.mandarinSorbet200',
	},

	cost: {
		color: 'colors.light1',
		position: 'relative',
	},
	strikeThroughStyles: {
		textDecoration: 'line-through',
		textDecorationColor: `${colorPalette.systemRed1}`,
	},
	discountedCost: {
		position: 'absolute',
		bottom: '100%',
		left: '50%',

		color: 'colors.light1',

		transform: 'translateX(-50%)',
	},
	divider: {
		width: '100%',
		borderBottom: `1px solid ${colorPalette.dark2}`,
	},
	planDetails: {
		alignItems: 'center',
		gap: '4px',
		height: '150px',
	},
};
